import { batch, signal } from '@preact/signals-react';
import { t } from 'i18next';
import { RuleCategory } from '../../../common/enums/RuleCategory';
import { PROFILE_MAX_NAME_LENGTH } from '../components/ProfileNameInput';
import { FuzzerProfile } from '../models/FuzzerProfile';
import { FuzzerRule } from '../models/FuzzerRule';
import { ProfileStore } from './ProfileStore';

type State = {
  profile: FuzzerProfile;
  isEditable: boolean;
};

export class FuzzerStore extends ProfileStore {
  private static instance: FuzzerStore | null = null;

  // Additional fields needed for FuzzerTable to render sucessfully
  readonly complianceRules = signal(<Map<RuleCategory, FuzzerRule[]>>new Map());
  readonly vulnerabilityRules = signal(<Map<RuleCategory, FuzzerRule[]>>new Map());

  static getInstance() {
    if (FuzzerStore.instance === null) {
      FuzzerStore.instance = new FuzzerStore();
    }
    return FuzzerStore.instance;
  }

  setStore(state: State) {
    const { profile, isEditable } = state;
    const profileName = profile.getName();
    this.originalProfileName = profileName;
    this.editable = isEditable;

    batch(() => {
      this.editableProfileName.value = profileName ? t('createProfileForm.copyOf', { profileName }).substring(0, PROFILE_MAX_NAME_LENGTH) : '';
      this.disabledRules.value = profile.getDisableRulesNumbers();
    });
  }

  setComplianceRules(value: Map<RuleCategory, FuzzerRule[]>) {
    this.complianceRules.value = value;
  }

  setVulnerabilityRules(value: Map<RuleCategory, FuzzerRule[]>) {
    this.vulnerabilityRules.value = value;
  }
}
